.accommodationsPage {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	width: 100%;
	gap: 0.5rem;
	box-sizing: border-box;

	& .accommodationTable {
		min-width: 0;
	}

	& .accommodationCell {
		padding: 1rem;
		width: fit-content;
		max-width: 100px;
		padding-left: 0.5rem;
		min-width: 0;
		text-wrap: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	& .accommodationRow {
		background-color: transparent !important;
	}
}

.nameCell {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
}

.searchToolbarWrapper {
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 1rem;
	align-items: center;
}

.filterValue:global(.MuiTypography-root),
.filterOption :global(.MuiListItemText-primary) {
	font-size: 0.875rem;
	line-height: 20px;
}

.settingsAccommodationsPage {
	align-items: stretch;
	gap: 0.75rem;

	& .nameCell :global(.MuiTypography-root) {
		font-size: 0.9375rem;
	}
}

.settingsDescription:global(.MuiTypography-root) {
	margin: 0;
	color: #525252;
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 1.5;
}

.settingsDescriptionTooltip {
	display: inline-flex;
	width: 16px;
	height: 16px;
	margin-left: 6px;
	align-items: center;
	justify-content: center;
	vertical-align: text-bottom;
	border-radius: 999px;
}

.settingsDescriptionTooltip:focus-visible {
	outline: 2px solid #0b6f85;
	outline-offset: 2px;
}

.settingsSelected:global(.MuiTypography-root) {
	margin: 0;
	color: #0b6f85;
	font-size: 0.875rem;
	font-weight: 500;
	line-height: 1.35;
	white-space: nowrap;
}

.tableToolbar {
	display: flex;
	flex-direction: row;
	background-color: #f9fafb;
	border: 0.61px solid #e2e2e2;
	border-radius: 10px;
	padding: 0.75rem;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	flex-wrap: wrap;
	gap: 0.5rem;
	box-sizing: border-box;

	& .selected:global(.MuiTypography-root) {
		color: #0b6f85;
		font-weight: 500;
		font-size: 0.9375rem;
		line-height: 1.5;
	}
}

.buttonWrapper {
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;

	& :global(.MuiButton-root) {
		height: 35px;
		min-width: fit-content;
	}
}

.noResultsImage,
.noTestTakersImage {
	align-self: center;
	width: 100%;
}

.profileBadgeTag:global(.MuiChip-root) {
	justify-content: center;
	align-items: center;
	width: fit-content;
	height: 28px;
	max-height: 28px;
	padding-left: 7px;
	padding-right: 7px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	text-align: center;
}

.notProctoredBadge:global(.MuiChip-root) {
	display: flex;
	justify-content: center;
	align-items: center;
	width: fit-content;
	height: 28px;
	padding-left: 7px;
	padding-right: 7px;
}

.noAccommodationBadge:global(.MuiChip-root) {
	display: flex;
	justify-content: center;
	align-items: center;
	width: fit-content;
	height: 28px;
	padding-left: 7px;
	padding-right: 7px;
}

.backButtonWrapper {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	justify-content: space-between;
	width: 100%;

	& .title {
		color: #333333;
		font-weight: 600;
		font-size: 1.125rem;
		line-height: 1.4;
		flex-shrink: 0;
	}
}

.sideBlock {
	min-width: 0;
	max-width: 200px;
	display: flex;
	width: 100%;
}

@media (max-width: 768px) {
	.accommodationsPage {
		padding: 0.5rem;

		& .accommodationCell {
			max-width: unset;
		}
	}

	.searchToolbarWrapper {
		flex-direction: column;
	}

	.tableToolbar {
		flex-direction: column;
		justify-content: center;
	}

	.buttonWrapper {
		flex-direction: column;
		width: 100%;

		& :global(.MuiButton-root) {
			min-width: unset;
			width: 100%;
		}
	}

	.backButtonWrapper {
		flex-direction: column;
		align-items: flex-start;
	}
}
